import _createClass from "/Users/och/Downloads/contentlab_frontend-main-1/node_modules/@babel/runtime/helpers/esm/createClass";
import _classCallCheck from "/Users/och/Downloads/contentlab_frontend-main-1/node_modules/@babel/runtime/helpers/esm/classCallCheck";
export var Range = /*#__PURE__*/_createClass(function Range(x, y) {
  _classCallCheck(this, Range);
  this.position = {
    x: x,
    y: y
  };
});